
function videoResponsiveKeyframe() {
    let ww = $(window).width();
    if (ww <= 768) {
        $('.video-responsive-keyframe iframe').each(function (index) {
            $(this).width(ww);
            $(this).height(ww * 9 / 16);
        });
    } else {
        let hw = $(window).height();
        let headerHeight = $('.course-header').height() + 40; //padding: 20px;

        let width = $('.course-content-inner').width() > 1320 ? 1280 : $('.course-content-inner').width() - 40; //pading: 20px
        $('.video-responsive-keyframe iframe').each(function (index) {
            let height = hw - headerHeight - 40; //padding: 20px;
            if (width * 9 > height * 16) {
                $(this).width(height * 16 / 9);
                $(this).height(height);
            } else {
                $(this).width(width);
                $(this).height(width * 9 / 16);
            }
        })
    }
}

window.onresize = function () {
    videoResponsiveKeyframe();
};

function make_button_watched(id) {
    //Add the clicked button class
    $('.highlight-watched li[data-id=' + id + ']').addClass('watched');
}
function make_button_unwatched(id) {
    //Add the clicked button class
    $('.highlight-watched li[data-id=' + id + ']').removeClass('watched');
}

function load_video_keyframe(id) {
    //load video if chưa load
    let $video_responsive_keyframe = $('#video-responsive-keyframe-' + id);
    if ($video_responsive_keyframe.length && $video_responsive_keyframe.children('iframe').length === 0) {
        let src = $video_responsive_keyframe.data('src');
        let iframe = `<iframe src="` + src + `" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen uk-responsive></iframe>`;
        $video_responsive_keyframe.append(iframe);
        videoResponsiveKeyframe();
    }
}

// let lessonDetailKey = 'lesson_detail_active';

// function setLessonDetailToLocalStorage(lessonDetailId) {
//     let lesson_detail_active = getLessonDetailToLocalStorage();
//     lesson_detail_active.push(lessonDetailId);
//     localStorage.setItem(lessonDetailKey, JSON.stringify(lesson_detail_active))
// }

// function removeLessonDetailToLocalStorage(lessonDetailId) {
//     let lesson_detail_active = getLessonDetailToLocalStorage();
//     lesson_detail_active = lesson_detail_active.filter(function(item) {
//         return item !== lessonDetailId
//     });
//     localStorage.setItem(lessonDetailKey, JSON.stringify(lesson_detail_active))
// }

// function getLessonDetailToLocalStorage() {
//     let lesson_detail_active = localStorage.getItem(lessonDetailKey);
//     if (lesson_detail_active !== undefined && lesson_detail_active != null) {
//         return JSON.parse(lesson_detail_active);
//     }
//     return [];
// }

$(document).on('click', 'a.click-wait-loading', function () {
    // let href = $(this).attr('href');
    $(this).addClass("disable-click");
    $(this).closest('li').addClass('waiting').removeClass('uk-active');
    // window.location = href;
});
$(document).on('click', '.highlight-watched li', function () {
    let id = $(this).data('id');
//     setLessonDetailToLocalStorage(id)
//     make_button_watched(id);
    load_video_keyframe(id);
});
$(document).on('click', '.btn-lesson-toggle-checked', function (){
    let $btn = $(this);
    let url = $btn.data('url');
    let dataForm = $btn.data('form');
    $btn.prop('disabled', true);
    $.ajax({
        type: 'POST',
        url: url,
        data: dataForm,
        dataType: 'json',
        success: function (resp) {
            switch (resp.code){
                case 1:
                    if (resp.data.sh_isread === 1){
                        $btn.html(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L18 18" stroke="#EB5757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Bỏ đánh dấu đã học`)
                        // setLessonDetailToLocalStorage(resp.data.sh_lessondetailid)
                        make_button_watched(resp.data.sh_lessondetailid);
                        // load_video_keyframe(resp.data.sh_lessondetailid);
                    }else{
                        $btn.html(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17L4 12" stroke="#219653" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Đánh dấu đã học`)
                        // removeLessonDetailToLocalStorage(resp.data.sh_lessondetailid)
                        make_button_unwatched(resp.data.sh_lessondetailid)
                    }
                    break;
                default:
            }

            $btn.prop('disabled', false);
        }
    });
})

$(document).ready(function () {
    videoResponsiveKeyframe();
    // let lesson_detail_active = getLessonDetailToLocalStorage();
    // for (let i = 0; i < lesson_detail_active.length; i++) {
    //     let id = lesson_detail_active[i];
    //     make_button_watched(id);
    // }
});
